module.exports = __webpack_public_path__ + "img/twitter-logo.642452b2.svg";